import { CustomFilter } from "@/types/custom-filter";

import { FalconPaymentStatus } from "@/enums/falcon/falcon-payment-status.enum";
import i18n from "@/i18n";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon payment status filter
 */
export const falconPaymentStatusFilter: CustomFilter = {
  falconPaymentStatus(value: any): string {
    value = +value as FalconPaymentStatus;
    if (value === FalconPaymentStatus.Unsettled) {
      value = i18n.t(I18nMessageKey.SharedFiltersPaymentStatusUnsettledText);
    } else if (value === FalconPaymentStatus.Settled) {
      value = i18n.t(I18nMessageKey.SharedFiltersPaymentStatusSettledText);
    } else {
      value = "";
    }
    return value;
  }
};
